import React, { useState, useEffect, useMemo } from 'react';
import { processChartData, formatChartOptions } from './effectsHelper';
import ApexChartWrapper from '../ApexChartWrapper';
import SkeletonLoader from '../../../../components/SkeletonLoader';
import useStyles from './styles';

export default function Charts (props) {

    const {
      data: chartData,
      themeOptions,
      type,
      isLoading,
    } = props;

    const classes = useStyles();
    const [chartKey, setChartKey] = useState(0);
    const { series: chartSeries, options: chartOptions } = useMemo(() => {
        
        if (!chartData?.length) {
            // Return stable empty structure
            return { series: [], options: themeOptions || {} }; 
        }
        
        // This process is now fully isolated from React's state setters.
        const processed = processChartData(chartData, type);
        const formatted = formatChartOptions(processed, themeOptions, type);
        
        // Return stable objects derived from calculation
        return { series: formatted.series, options: formatted.options };
        
    }, [chartData ]);

    // --- New Consolidated Effect ---
    useEffect(() => {
      return () => {
        setChartKey(prev => prev + 1);
      };
      
    }, [chartData, props.type, props.themeOptions]); 

    return (
      <>
      {isLoading || !chartSeries?.length
? (
        <SkeletonLoader />
      )
: (
        <div className={classes.chartWrapper}>
          <ApexChartWrapper
            chartKey={chartKey}
            options={chartOptions}
            series={chartSeries}
            type='donut'
            height='200'
            stroke={''}
          />
        </div>
      )}
      </>
    );
}